import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  PaginatedHolidaysDocument,
  RemoveHolidayMutation,
  RemoveHolidayMutationVariables,
  RemoveHolidayDocument,
} from "@/graphql/__generated__/graphql";
import { resetPaginationField } from "@/store/paginationStore";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

/**
 * Custom hook for removing a holiday and handling the necessary cache updates.
 * @returns {Object} - Contains the removeHolidayMutation function, loading state, and error state.
 */
export default function useRemoveHolidayMutationHook(): {
  removeHolidayMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);

  const [removeHolidayMutation, { loading, error }] = useMutation<RemoveHolidayMutation, RemoveHolidayMutationVariables>(
    RemoveHolidayDocument, {
      onCompleted: () => {
      // Reset pagination to first page to avoid cache inconsistencies
        resetPaginationField("paginatedHolidays");

        toast(CustomToastComponent, {
          toastId: "holiday-removed-success",
          data: {
            title: t("toasts.holidayremovedsuccessfully"),
            type: "success",
          },
        });
      },
      refetchQueries: [
        {
          query: PaginatedHolidaysDocument,
          variables: {
            first: 10,
            after: null,
            currentPage: 0,
            filters: {
              date: null,
              provinces: null,
            },
            sort: null,
          },
        },
      ],
    });

  return {
    removeHolidayMutation,
    loading,
    error,
  };
}
